import React from 'react'

import { Container } from '../Container'
import { TimelineStore } from './store/TimelineStore'
import { TimelineContainer } from './TimelineContainer'

interface IProps {
    masterTrackingNo?: string
    shipmentId?: string
    isSubWidget?: boolean
    withManufacturingLabels?: boolean
    onLoaded?: (isShowHeaderShadow: boolean, isShowFooterShadow: boolean) => void
    onScroll?: (event: React.UIEvent<HTMLDivElement>) => void
    showScrollShadow?: {
        top?: boolean
        bottom?: boolean
    }
    noDataText?: JSX.Element
}

export const Timeline = (props: IProps): JSX.Element => (
    <Container store={TimelineStore} isSubWidget={props.isSubWidget}>
        <TimelineContainer
            masterTrackingNo={props.masterTrackingNo}
            shipmentId={props.shipmentId}
            withManufacturingLabels={props.withManufacturingLabels}
            onLoaded={props.onLoaded}
            showScrollShadow={props.showScrollShadow}
            onScroll={props.onScroll}
            noDataText={props.noDataText}
            isSubWidget={props.isSubWidget}
        />
    </Container>
)
